import constants from './constants';

// function setIsDrawing(isDrawing) {

//   return {
//     type: constants.SET_IS_DRAWING,
//     payload: isDrawing,
//   };

// }

// function setGeofencesData({ data, count } = {}) {

//   return (dispatch, getState) => {

//     const { geofencesData } = getState().geofences;
//     const newGeofencesData = geofencesData ? [...geofencesData, ...data] : data;
//     const hasMore = count !== newGeofencesData.length;
//     const offset = newGeofencesData.length;

//     dispatch({
//       type: constants.SET_GEOFENCES_DATA,
//       payload: {
//         data: newGeofencesData,
//         offset,
//         hasMore,
//       },
//     });

//   };

// }

// function setGeofenceToEdit(geofenceId) {

//   return {
//     type: constants.SET_GEOFENCE_TO_EDIT,
//     payload: geofenceId,
//   };

// }

// function setGeometryPolygon(geometryPolygon) {

//   return {
//     type: constants.SET_GEOMETRY_POLYGON,
//     payload: geometryPolygon,
//   };

// }

// function setSearch(value) {

//   return {
//     type: constants.SET_SEARCH_GEOMETRY_POLYGON,
//     payload: value,
//   };

// }

// function createGeometryPolygon(newGeofence) {

//   return (dispatch, getState) => {

//     const { geofencesData, hasMore } = getState().geofences;
//     const newGeofencesData = !hasMore ? [...geofencesData, newGeofence] : [...geofencesData];

//     dispatch({
//       type: constants.CREATE_GEOMETRY_POLYGON,
//       payload: newGeofencesData,
//     });

//   };

// }

// function addMultiplesGeofences(geofences) {

//   return (dispatch, getState) => {

//     const { geofencesData, hasMore } = getState().geofences;
//     if (hasMore) return;

//     const newGeofencesData = [...geofencesData, ...geofences];

//     dispatch({
//       type: constants.ADD_MULTIPLES_GEOFENCES,
//       payload: newGeofencesData,
//     });

//   };

// }

// function updateGeometryPolygon(geofenceUpdated) {

//   return (dispatch, getState) => {

//     const { geofences } = getState();
//     const { geofencesData } = geofences;
//     const newGeofencesData = [...geofencesData];
//     const { id: updateId } = geofenceUpdated;
//     const indexTarget = newGeofencesData.findIndex(({ id }) => id === updateId);

//     if (indexTarget >= 0) {

//       newGeofencesData[indexTarget] = geofenceUpdated;
//       dispatch({
//         type: constants.UPDATE_GEOMETRY_POLYGON,
//         payload: newGeofencesData,
//       });

//     }

//   };

// }

// function deleteGeometryPolygon(geofenceDeletedId) {

//   return (dispatch, getState) => {

//     const { geofences } = getState();
//     const { geofencesData } = geofences;
//     const newGeofencesData = [...geofencesData];
//     const indexTarget = newGeofencesData.findIndex(({ id }) => id === geofenceDeletedId);

//     if (indexTarget >= 0) {

//       newGeofencesData.splice(indexTarget, 1);
//       dispatch({
//         type: constants.DELETE_GEOMETRY_POLYGON,
//         payload: newGeofencesData,
//       });

//     }

//   };

// }

function resetState() {

  return {
    type: constants.RESET_STATE,
  };

}

export default {
//   setIsDrawing,
//   setGeofencesData,
//   setGeofenceToEdit,
//   setGeometryPolygon,
//   setSearch,
//   createGeometryPolygon,
//   updateGeometryPolygon,
//   deleteGeometryPolygon,
//   addMultiplesGeofences,
  resetState,
};
